import React, { useState } from "react";
import firebase from "../../../utils/firebase";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import styles from "assets/jss/material-kit-react/views/loginPage.js";
import { registerUser, loginUser } from "../../../slices/authSlice";
import { setAlert } from "../../../slices/alertSlice";
import { Link, useHistory } from "react-router-dom";
import {
  TextField,
  FormControl,
  InputAdornment,
  makeStyles,
} from "@material-ui/core";
import Button from "../../../components/MaterialKit/CustomButtons/Button";

import CardBody from "components/MaterialKit/Card/CardBody.js";
import CardHeader from "components/MaterialKit/Card/CardHeader.js";

import CardFooter from "components/MaterialKit/Card/CardFooter";
import { REGISTER, LOGIN } from "../../../constants/routes";
import { login } from "../../../api/authRequests";
const useStyles = makeStyles(styles);

const AutoLogin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { email, uid } = firebase.auth().currentUser;
  const [formData, setFormdata] = useState({
    email: email,
    password: uid,
  });
  const {
    auth: { loading },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(formData));
  };
  const classes = useStyles();
  return (
    <form onSubmit={onSubmit} className={classes.form}>
      <CardHeader color="black" className={classes.cardHeader}>
        <h3>Welcome {firebase.auth().currentUser.displayName}</h3>
      </CardHeader>

      <CardFooter>
        <Button type="submit" color="warning" round fullWidth loading={loading}>
          Continue
        </Button>
      </CardFooter>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          padding: "1rem",
        }}
      >
        <div
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h6>First register from google/facebook/steam then continue </h6>
          <Link
            to={LOGIN}
            style={{
              textDecoration: "none",
            }}
          >
            <Button
              onClick={() => {
                firebase.auth().signOut();
              }}
              simple
              variant="contained"
              color="primary"
              size="lg"
            >
              Back
            </Button>
          </Link>
        </div>
      </div>
    </form>
  );
};

export default AutoLogin;
